import { DragDropContext, Droppable } from "react-beautiful-dnd";
import PropTypes from "prop-types";
import { StyledTable } from "./DndTable.styles";

const DndTable = ({ handleDragEnd, children }) => (
  <DragDropContext onDragEnd={handleDragEnd}>
    <Droppable droppableId="dnd-list" direction="vertical">
      {(provided) => (
        <StyledTable border="0" cellSpacing="0" cellPadding="0">
          <thead>
            <tr>
              <th className="border-none text-center" width={150}>
                Display Order
              </th>
              <th className="border-none" width={450}>
                Title
              </th>
              <th className="border-none" width={500}></th>
            </tr>
          </thead>
          <tbody {...provided.droppableProps} ref={provided.innerRef}>
            {children}
            {provided.placeholder}
          </tbody>
        </StyledTable>
      )}
    </Droppable>
  </DragDropContext>
);

DndTable.propTypes = {
  handleDragEnd: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default DndTable;
